import Navbar  from "../NavBar/NavBar.js";
import Footer from "../Home/Footer.js"
import Whatsapp from "../Home/Whatsapp.js";
import SL from "./groupe_pages/SL/SL.js"
// import SL2 from "./groupe_pages/SL/SL2.js"
import SL22 from "./groupe_pages/SL/SL22.js"
import SL33 from "./groupe_pages/SL/SL33.js"
import Spinner from "../Home/Spinner.js";
import { useEffect } from "react";




const SolutionLight = () => {
  useEffect(() => {
    // ✅ TITLE (SEO + conversion + local)
    document.title =
      "Éclairage Architectural Maroc | LED, Lightbox & Design Moderne – UNIK SYSTEM";

    // ✅ DESCRIPTION (CTR + mots clés + CTA)
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Spécialiste en éclairage architectural au Maroc : plafonds lumineux LED, lightbox murales et solutions design sur mesure. Sublimez vos espaces avec UNIK SYSTEM. Devis gratuit."
    );

    // ✅ KEYWORDS
    let keywords = document.querySelector("meta[name='keywords']");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.setAttribute("name", "keywords");
      document.head.appendChild(keywords);
    }
    keywords.setAttribute(
      "content",
      "éclairage architectural maroc, lighting maroc, plafond lumineux LED, lightbox murale maroc, éclairage design maroc, éclairage intérieur moderne maroc, LED maroc"
    );

    // ✅ ROBOTS
    let robots = document.querySelector("meta[name='robots']");
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "index, follow");

    // ✅ CANONICAL
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute(
      "href",
      "https://unik-system.com/light-maroc"
    );

    // ✅ OPEN GRAPH (Facebook / WhatsApp)
    const setMetaProperty = (property, content) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMetaProperty(
      "og:title",
      "Éclairage Architectural Maroc – UNIK SYSTEM"
    );
    setMetaProperty(
      "og:description",
      "Plafonds lumineux LED, lightbox et éclairage design sur mesure au Maroc."
    );
    setMetaProperty(
      "og:image",
      "https://unik-system.com/static/media/34Plafond%20architectural%20moderne.19248fbaedfa4a34ad0c.webp"
    );
    setMetaProperty(
      "og:url",
      "https://unik-system.com/light-maroc"
    );
    setMetaProperty("og:type", "website");

    // ✅ TWITTER
    let twitterCard = document.querySelector("meta[name='twitter:card']");
    if (!twitterCard) {
      twitterCard = document.createElement("meta");
      twitterCard.setAttribute("name", "twitter:card");
      document.head.appendChild(twitterCard);
    }
    twitterCard.setAttribute("content", "summary_large_image");

    let twitterImage = document.querySelector("meta[name='twitter:image']");
    if (!twitterImage) {
      twitterImage = document.createElement("meta");
      twitterImage.setAttribute("name", "twitter:image");
      document.head.appendChild(twitterImage);
    }
    twitterImage.setAttribute(
      "content",
      "https://unik-system.com/static/media/34Plafond%20architectural%20moderne.19248fbaedfa4a34ad0c.webp"
    );

  }, []);


    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <SL/>
            {/* <SL2/> */}
            <SL22/>
            <SL33/>
            <Whatsapp/>
            <Footer/>
        </div>    
    )
};

export default SolutionLight;